"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var RupeeLine = function RupeeLine(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_7574_62155)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 0C4.02975 0 0 4.02975 0 9C0 13.9703 4.02975 18 9 18C13.9703 18 18 13.9703 18 9C18 4.02975 13.9703 0 9 0ZM9 16.506C4.85475 16.506 1.494 13.1453 1.494 9C1.494 4.85475 4.85475 1.494 9 1.494C13.1453 1.494 16.506 4.85475 16.506 9C16.506 13.1453 13.1453 16.506 9 16.506ZM5.616 4.824H12.114V5.85H9.756C10.098 6.18525 10.3282 6.6345 10.3853 7.13625L10.386 7.146V7.218H12.06V8.136H10.422V8.208C10.074 9.441 9.00825 10.3485 7.71525 10.4572L7.704 10.458H7.578L10.584 14.202H8.766L5.58 10.17V9.504H6.534C7.776 9.504 8.622 9.036 8.838 8.244V8.136H5.598V7.218H8.856V7.128C8.64 6.372 7.974 5.922 6.894 5.922H5.616V4.824Z"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_7574_62155"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "18",
    height: "18"
  }))));
};
var _default = exports["default"] = RupeeLine;